import { combineReducers } from 'redux';
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import taskReducer from "./taskReducer";
import authReducer from "./authReducer";
import financeReducer from "./financeReducer";
import playerReducer from './playerReducer';

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  task: taskReducer,
  auth: authReducer,
  finance: financeReducer,
  player: playerReducer
});

export default rootReducer;
